<script setup>

const props = defineProps({
    percent: {
        type: Number,
        required: true
    }
})

</script>

<template>
    <!-- <div class="progress-circle"> -->
      <!-- <span class="progress-circle-percent" :style="[{'color': `var(--${color})`}]">{{percent}}%</span> -->
      <svg width="120" height="120" viewBox="0 0 120 120" class="progress-circle-svg">
        <circle
          cx="60"
          cy="60"
          r="54"
          fill="none"
          stroke="#e6e6e6"
          stroke-width="12" />

          <!-- Define Gradient Pattern -->
      <defs>
        <pattern id="diagonal-stripes" patternUnits="userSpaceOnUse" width="10" height="10">
          <rect width="5" height="10" fill="#36C55C" />
          <rect x="5" width="5" height="10" fill="#1C1C1E" />
        </pattern>
      </defs>
        
        <circle
          class="progress-circle-line"
          :style="[{'stroke-dashoffset': `calc(100 - ${percent})`}]"
          cx="60"
          cy="60"
          r="54"
          fill="none"
          stroke="#f77a52"
          stroke-width="12"
          pathLength="100" />
      </svg>
    <!-- </div> -->
    
  </template>


<style lang="scss" scoped>
.progress {
  &-circle {
    position: relative;
    margin-bottom: 20px;
    width: 120px;
    height: 120px;
    &-svg {
      transform: rotate(-90deg);
    }
    &-percent {
      position: absolute;
      left: 0;
      width: 100%;
      top: 0;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: bold;
      font-size: 18px;
    }
    &-line {
      stroke-dasharray: 100;
      transition: .5s;
    }
  }
}
</style>